import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useUpdateDispatcherProfile = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onUpdateDispatcherProfileError = (err: AxiosError<ErrorHttpResponse>) => {
        const errorMessage = err?.response?.data?.message;

        // Handle case where message is an object (e.g., validation errors)
        let displayMessage = 'Something went wrong while updating driver profile.';

        if (typeof errorMessage === 'string') {
            displayMessage = errorMessage;
        } else if (typeof errorMessage === 'object' && errorMessage !== null) {
            // Extract first error message from object
            const firstKey = Object.keys(errorMessage)[0];
            displayMessage = errorMessage[firstKey] || displayMessage;
        }

        toast.error(displayMessage);
    };

    const onUpdateDispatcherProfileSuccess = (resetFn: (...args: any) => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Driver profile updated successfully.');
        resetFn();
    };

    const updateDispatcherProfile = (data: any, driverId: string, resetFn: (...args: any) => void) => {
        const formData = new FormData();

        if (data.profilePicture instanceof File) {
            formData.append('profilePicture', data.profilePicture, data.profilePicture.name);
        } else {
            console.warn('No valid profilePicture provided');
        }

        const url: HttpConfig = {
            url: `api/v1/dispatchers/${driverId}/update-info`,
            method: 'patch',
            data: formData,
        };

        request(url, onUpdateDispatcherProfileSuccess(resetFn), setLoading, onUpdateDispatcherProfileError);
    };

    return { updateDispatcherProfile, loading };
};

export default useUpdateDispatcherProfile;
